import datePicker from './date-picker.vue'

export default datePicker
